import React from "react";

import "./styles.css"

export const Footer = () => (
    <footer className="footerContainer">
        <h2 className="footerTitle">Katja Runge</h2>
        <p className="footerText">Hamburg Germany <br /> krunge.olivera@gmail.com</p>
    </footer>
);